<template>
<ItpPage
  :size="size"
  :header="documentTitle"
  :loaded="loaded"
  :noShow="!loaded"
  :modal="modal"
  itp-cname="Tariffs"
  :modalBindings="b_7315092382398562_modalBindings"
  @close="evh_7315092382398562_close($event, {})"
>
  <UcHeader
    :card="!modal"
    :modal="modal"
    :title="documentTitle"
    slot="header"
    v-if="loaded"
    @close="evh_2248226175642056_close($event, {})"
  >
  </UcHeader>
  <UcBody
    :card="!modal"
    :modal="modal"
    v-if="loaded"
  >
    <ItpDataTable
      tableId="Tariffs"
      editable
      :value="items"
      :rowTemplate="b_1040167445267876_rowTemplate"
      :columns="b_1040167445267876_columns"
      class="h-100"
      :style="b_1040167445267876_style"
      @save="evh_1040167445267876_save($event, {})"
      @delete="evh_1040167445267876_delete($event, {})"
    >
    </ItpDataTable>
  </UcBody>
  <UcFooter
    :card="!modal"
    :modal="modal"
    slot="footer"
    v-if="loaded"
  >
    <ItpButton
      :text="'Close'|gettext"
      variant="default"
      @click.prevent.stop="evh_1548630417156826_clickPreventStop($event, {})"
    >
    </ItpButton>
  </UcFooter>
  <template
    slot="footer"
    v-if="loaded"
  >
  </template>
</ItpPage>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

addRoute(
  {
    name: "tartiffs",
    path: "tariffs",
    component: "Tariffs"
  }
)

@Component()
export default class Tariffs extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "page",
  };

  beforeCreate() {
  }

  onItemsChanged(...args: any[]) {
    this.$app.repo.clearCache('list_object_by_type', { parameters: { object_type: 'tariff' } })
  }

  @Prop({
    type: String,
    default: "lg",
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  items!: any;

  async $$load_items() {
    return this.$fn.fetch('list_object_by_type', { parameters: { object_type: 'tariff' } }).then(d => _.sortBy(d, 'id'))
  }

  ux!: any;
  b_7315092382398562_modalBindings!: any;
  b_1040167445267876_rowTemplate!: any;
  b_1040167445267876_columns!: any;
  b_1040167445267876_style!: any;
  dataMembers = ['items', 'ux', 'b_7315092382398562_modalBindings', 'b_1040167445267876_rowTemplate', 'b_1040167445267876_columns', 'b_1040167445267876_style'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        items: null,
        ux: null,
        b_7315092382398562_modalBindings: {
          size: "lg",
        }
        ,
        b_1040167445267876_rowTemplate: {
          object_type: "tariff",
        }
        ,
        b_1040167445267876_columns: [{
          name: "code",
          header: this.$fn.pgettext("Tariff", "Code"),
          width: "80px",
          required: true,
        }
          ,
        {
          name: "name",
          header: this.$fn.pgettext("Tariff", "Name"),
          width: "200px",
          required: true,
        }
          ,
        {
          name: "description",
          header: this.$fn.pgettext("Tariff", "Description"),
        }
          ,
        ]
        ,
        b_1040167445267876_style: {
          minHeight: "200px",
        }
        ,
      },
    }
  }

  get document() {
    if (this.loaded) {

      return {
        title: [this.$fn.pgettext("Tariffs|Header", "Configure tariffs")
          ,
        ]
        ,
        icon: this.$config.tariff.icon,
      }
    }
    return null;
  }

  async act_7315092382398562_closeModal_2964_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_7315092382398562_closeModal_2964, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
        cancel: true,
      }
      ,
    }
  }

  async evh_7315092382398562_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
  }

  async evh_2248226175642056_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
  }

  async act_1040167445267876_script_2968_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_1040167445267876_script_2968, alias=undefined
    $event.data.waitFor(this.$fn.crud('object_by_type').upsert($event.data.row).then(this.onItemsChanged))
  }

  async act_1040167445267876_script_2968_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_1040167445267876_script_2968, alias=undefined
    return {
      value: () => this.act_1040167445267876_script_2968_getActionArgs_value($event),
    }
  }

  async evh_1040167445267876_save(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1040167445267876_save.executeFromDOM(this, event, scope);
  }

  async act_1040167445267876_script_2970_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_1040167445267876_script_2970, alias=undefined
    $event.data.waitFor(this.$fn.crud('object_by_type').delete($event.data.row).then(this.onItemsChanged))
  }

  async act_1040167445267876_script_2970_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_1040167445267876_script_2970, alias=undefined
    return {
      value: () => this.act_1040167445267876_script_2970_getActionArgs_value($event),
    }
  }

  async evh_1040167445267876_delete(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1040167445267876_delete.executeFromDOM(this, event, scope);
  }

  async evh_1548630417156826_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1548630417156826_clickPreventStop.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_closeModal_2964: actions.CloseModalAction;
    evh_7315092382398562_close_2963: actions.EventHandlerImpl;
    evh_7315092382398562_close: actions.EventHandlerGroup;
    act_2248226175642056_closeModal_2966: actions.CloseModalAction;
    evh_2248226175642056_close_2965: actions.EventHandlerImpl;
    evh_2248226175642056_close: actions.EventHandlerGroup;
    act_1040167445267876_script_2968: actions.ScriptAction;
    evh_1040167445267876_save_2967: actions.EventHandlerImpl;
    evh_1040167445267876_save: actions.EventHandlerGroup;
    act_1040167445267876_script_2970: actions.ScriptAction;
    evh_1040167445267876_delete_2969: actions.EventHandlerImpl;
    evh_1040167445267876_delete: actions.EventHandlerGroup;
    act_1548630417156826_closeComponent_2972: actions.CloseComponentAction;
    evh_1548630417156826_clickPreventStop_2971: actions.EventHandlerImpl;
    evh_1548630417156826_clickPreventStop: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_closeModal_2964 = new actions.CloseModalAction(
      {
        actionArgs: this.act_7315092382398562_closeModal_2964_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_close_2963 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_closeModal_2964,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_7315092382398562_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_close_2963],
      }
    );
    const act_2248226175642056_closeModal_2966 = new actions.CloseModalAction(
      {
        events: [],
      }
    );
    const evh_2248226175642056_close_2965 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_closeModal_2966,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_2248226175642056_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_2248226175642056_close_2965],
      }
    );
    const act_1040167445267876_script_2968 = new actions.ScriptAction(
      {
        actionArgs: this.act_1040167445267876_script_2968_getActionArgs,
        events: [],
      }
    );
    const evh_1040167445267876_save_2967 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_script_2968,
        event: "save",
        displayName: "script",
      }
    );
    const evh_1040167445267876_save = new actions.EventHandlerGroup(
      {
        handlers: [evh_1040167445267876_save_2967],
      }
    );
    const act_1040167445267876_script_2970 = new actions.ScriptAction(
      {
        actionArgs: this.act_1040167445267876_script_2970_getActionArgs,
        events: [],
      }
    );
    const evh_1040167445267876_delete_2969 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_script_2970,
        event: "delete",
        displayName: "script",
      }
    );
    const evh_1040167445267876_delete = new actions.EventHandlerGroup(
      {
        handlers: [evh_1040167445267876_delete_2969],
      }
    );
    const act_1548630417156826_closeComponent_2972 = new actions.CloseComponentAction(
      {
        events: [],
      }
    );
    const evh_1548630417156826_clickPreventStop_2971 = new actions.EventHandlerImpl(
      {
        action: act_1548630417156826_closeComponent_2972,
        event: "click.prevent.stop",
        displayName: "closeComponent",
      }
    );
    const evh_1548630417156826_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_1548630417156826_clickPreventStop_2971],
      }
    );
    return {
      act_7315092382398562_closeModal_2964,
      evh_7315092382398562_close_2963,
      evh_7315092382398562_close,
      act_2248226175642056_closeModal_2966,
      evh_2248226175642056_close_2965,
      evh_2248226175642056_close,
      act_1040167445267876_script_2968,
      evh_1040167445267876_save_2967,
      evh_1040167445267876_save,
      act_1040167445267876_script_2970,
      evh_1040167445267876_delete_2969,
      evh_1040167445267876_delete,
      act_1548630417156826_closeComponent_2972,
      evh_1548630417156826_clickPreventStop_2971,
      evh_1548630417156826_clickPreventStop,
    }
  }
}

Vue.component("Tariffs", Tariffs);

</script>